document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.hero-media-slideshow').forEach(function (sectionEl) {
    var swiperEl = sectionEl.querySelector('.hero-media-slideshow__swiper');
    if (!swiperEl) return;

    var autoplayEnabled = swiperEl.getAttribute('data-autoplay') === 'true';
    var delayAttr = parseInt(swiperEl.getAttribute('data-autoplay-delay') || '5000', 10);

    var autoplayConfig = autoplayEnabled
      ? {
          delay: isNaN(delayAttr) ? 5000 : delayAttr,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }
      : false;

    var nextEl = sectionEl.querySelector('.hero-media-slideshow__next');
    var prevEl = sectionEl.querySelector('.hero-media-slideshow__prev');
    var paginationEl = sectionEl.querySelector('.hero-media-slideshow__pagination');

    // Initialize Swiper
    var swiper = new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 800,
      autoplay: autoplayConfig,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });

    // Video-based slide timing logic
    var currentVideoEndedHandler = null;
    var currentVideo = null;

    function isMobile() {
      return window.innerWidth <= 749;
    }

    function getActiveVideo(slide) {
      var videoWrapper = slide.querySelector('.hero-media-slideshow__video-wrapper');
      if (!videoWrapper) return null;

      var videoContainer = isMobile()
        ? videoWrapper.querySelector('.hero-media-slideshow__video--mobile')
        : videoWrapper.querySelector('.hero-media-slideshow__video--desktop');

      return videoContainer ? videoContainer.querySelector('video') : null;
    }

    function pauseAllVideos() {
      // Pause ALL videos in the slideshow to ensure only active slide plays
      var allVideos = sectionEl.querySelectorAll('video');
      allVideos.forEach(function (video) {
        video.pause();
        video.currentTime = 0;
      });
    }

    function handleSlideChange() {
      // Clean up previous video event listener
      if (currentVideo && currentVideoEndedHandler) {
        currentVideo.removeEventListener('ended', currentVideoEndedHandler);
      }

      // Pause ALL videos in the slideshow (including duplicates from loop mode)
      pauseAllVideos();

      var activeSlide = swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      var slideType = activeSlide.getAttribute('data-slide-type');

      if (slideType === 'video') {
        var video = getActiveVideo(activeSlide);

        if (video) {
          currentVideo = video;

          // Stop Swiper's autoplay for video slides
          if (swiper.autoplay && swiper.autoplay.running) {
            swiper.autoplay.stop();
          }

          // Play the video
          var playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.catch(function (error) {
              console.warn('Video autoplay failed:', error);
            });
          }

          // Create and attach ended event handler
          currentVideoEndedHandler = function () {
            if (autoplayEnabled) {
              // If autoplay is ON, advance to next slide
              swiper.slideNext();
            }
            // If autoplay is OFF, video just stops on last frame
          };

          video.addEventListener('ended', currentVideoEndedHandler);
        } else {
          // No video found, resume normal autoplay
          if (autoplayEnabled && swiper.autoplay && !swiper.autoplay.running) {
            swiper.autoplay.start();
          }
        }
      } else {
        // Image slide - use per-slide duration
        currentVideo = null;
        currentVideoEndedHandler = null;

        if (autoplayEnabled) {
          // Read the custom duration for this slide (in milliseconds)
          var slideDuration = parseInt(activeSlide.getAttribute('data-slide-duration'), 10);

          // Update Swiper's autoplay delay dynamically
          if (swiper.params.autoplay && !isNaN(slideDuration)) {
            swiper.params.autoplay.delay = slideDuration;
          }

          // Restart autoplay with the new delay
          if (swiper.autoplay && !swiper.autoplay.running) {
            swiper.autoplay.start();
          }
        }
      }
    }

    // Listen to slide change events
    swiper.on('slideChange', handleSlideChange);

    // Handle initial slide
    handleSlideChange();

    // Add aria-labels to pagination bullets for accessibility
    if (paginationEl) {
      swiper.on('paginationRender', function () {
        var bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
        bullets.forEach(function (bullet, index) {
          bullet.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        });
      });
    }
  });
});
